import { render } from "./ConfirmDialog.vue?vue&type=template&id=049895e9&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=049895e9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-049895e9"

export default script